class ValidateForm
{

    constructor(){

        // ------------------------------ 入力項目のチェック
        const required = $('#name1, #kana1, #email, #tel, #pref, #comment').get();
        const term = $('#agree')[0];
        const regExp = new RegExp(/[^\s　]/);
        const button = $('.contact-form__button');
        function check() {
            // 必須項目
            const b = required.every(function (e) {
                return regExp.test(e.value || '');
            });

            // & 利用規約
            button.toggleClass('contact-form__button--enabled', b && term.checked);
        }
        $('#mw_wp_form_mw-wp-form-5').on('change', check);
        // 戻るボタンで遷移してきた時、全て入力&チェック済みの場合がある
        setInterval(check, 0);

        // ------------------------------ エラーだったらクラス追加して赤枠に
        $('.contact-form__item').each(function (){
            const $this = $(this);
            if ($this.find('span.error').length > 0) {
                $this.addClass('contact-form__item--error')
            }
        });

    }

    // ---------------------------------------------------------------------------------------------------------
}

export default ValidateForm